import { useCallback } from 'react'

import { useNotification } from '@/hooks'
import { useEditingStateWithCtx } from '@/atoms'
import { roadSegmentsUtils } from '@/utils'

import { useDeleteRoadSegmentModal } from '../../../../modals/DeleteRoadSegmentModal'

export function useActions(segment: uui.domain.client.rm.SegmentException) {
  const toast = useNotification()
  const { setEditing } = useEditingStateWithCtx('segment')

  const { show: showDeleteRoadSegmentModal } = useDeleteRoadSegmentModal()

  const onExport = useCallback(async () => {
    try {
      roadSegmentsUtils.exportRoadSegmentsToKML([segment])
    } catch (e) {
      toast.error(e.message)
    }
  }, [toast, segment])

  const onDelete = useCallback(() => {
    showDeleteRoadSegmentModal()
  }, [showDeleteRoadSegmentModal])

  const onEdit = useCallback(() => setEditing([segment.id]), [setEditing, segment])

  return {
    onExport,
    onDelete,
    onEdit,
  }
}
